import { Component } from '@theme/component';

class HeaderMenu extends Component {
  #documentClickHandler;

  connectedCallback() {
    super.connectedCallback();
    this.#setupMenuInteractions();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#cleanupMenuInteractions();
  }

  #setupMenuInteractions = () => {
    const menuItems = this.querySelectorAll('.menu-list__list-item');

    menuItems.forEach((item) => {
      const link = item.querySelector(':scope > .menu-list__link');

      if (!link) return;

      const submenu = item.querySelector(':scope > .menu-list__submenu');
      const submenuList = item.querySelector(':scope > .menu-list__submenu-list');

      const hasSubmenu = submenu || submenuList;

      if (!hasSubmenu) return;

      link.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        console.log('clicked:', link.textContent.trim());

        this.#toggleSubmenu(item);
      });

      link.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          this.#toggleSubmenu(item);
        }
      });
    });

    this.#documentClickHandler = (event) => {
      if (!this.contains(event.target)) {
        this.#closeAllSubmenus();
      }
    };

    document.addEventListener('click', this.#documentClickHandler);
  };

  #cleanupMenuInteractions = () => {
    if (this.#documentClickHandler) {
      document.removeEventListener(
        'click',
        this.#documentClickHandler
      );
    }
  };

  #toggleSubmenu = (item) => {
    const isOpen = item.dataset.expanded === 'true';

    if (isOpen) {
      this.#closeSubmenu(item);
    } else {
      this.#closeOtherSubmenus(item);
      this.#openSubmenu(item);
    }
  };

  #openSubmenu = (item) => {
    item.dataset.expanded = 'true';

    const link = item.querySelector(':scope > .menu-list__link');

    if (link) {
      link.setAttribute('aria-expanded', 'true');
    }
  };

  #closeSubmenu = (item) => {
    item.dataset.expanded = 'false';

    const link = item.querySelector(':scope > .menu-list__link');

    if (link) {
      link.setAttribute('aria-expanded', 'false');
    }

    item
      .querySelectorAll(
        '.menu-list__list-item[data-expanded="true"]'
      )
      .forEach((child) => {
        child.dataset.expanded = 'false';

        const childLink = child.querySelector(
          ':scope > .menu-list__link'
        );

        if (childLink) {
          childLink.setAttribute(
            'aria-expanded',
            'false'
          );
        }
      });
  };

  #closeOtherSubmenus = (currentItem) => {
    const parentMenu = currentItem.parentElement;

    if (!parentMenu) return;

    parentMenu
      .querySelectorAll(':scope > .menu-list__list-item')
      .forEach((sibling) => {
        if (
          sibling !== currentItem &&
          sibling.dataset.expanded === 'true'
        ) {
          this.#closeSubmenu(sibling);
        }
      });
  };

  #closeAllSubmenus = () => {
    this.querySelectorAll(
      '.menu-list__list-item[data-expanded="true"]'
    ).forEach((item) => {
      this.#closeSubmenu(item);
    });
  };
}

if (!customElements.get('header-menu')) { 
  customElements.define('header-menu', HeaderMenu); 
}